export default class OrderAPI {
  static API_TOKEN = null;

  static API_VERSION = 1;

  static setApiToken (apiToken) {
    this.API_TOKEN = apiToken;
  }

  static purchaseOrder (data = {}) {
    return (
      fetch("/orders", {
        "body": JSON.stringify(data),
        "credentials": "same-origin",
        "headers": {
          "Authorization": `Token token=${this.API_TOKEN}`,
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelectorAll("meta[name=csrf-token]")[0].getAttribute("content")
        },
        "method": "POST"
      }).
        then(response => response.json())
    );
  }
}
